var map = {
	"./Albânia.png": 8549,
	"./Alemanha.png": 6083,
	"./Bélgica.png": 3877,
	"./Chéquia.png": 7258,
	"./Croácia.png": 240,
	"./Dinamarca.png": 938,
	"./Escócia.png": 4783,
	"./Eslováquia.png": 5186,
	"./Eslovénia.png": 8808,
	"./Espanha.png": 3620,
	"./França.png": 6419,
	"./Geórgia.png": 7924,
	"./Hungria.png": 3628,
	"./Inglaterra.png": 9947,
	"./Itália.png": 8444,
	"./Países Baixos.png": 2289,
	"./Polónia.png": 4568,
	"./Portugal.png": 4656,
	"./Roménia.png": 2065,
	"./Suíça.png": 6977,
	"./Sérvia.png": 4728,
	"./TBD.png": 754,
	"./TacaPalpitesEuro2024.png": 3042,
	"./Turquia.png": 9689,
	"./Ucrânia.png": 7384,
	"./Áustria.png": 7813
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5025;